import React, { Component } from 'react';
import './card-header.css';
import GeckoIcon from '../../icon/icon';

class GeckoCardHeader extends Component {

    renderTitle() {
        if (this.props.name || this.props.icon) {
            return (
                <h2 className="header-title">
                    {this.renderIcon()}
                    <span>{this.props.name}</span>
                </h2>
            );
        }

        return null;
    }

    renderIcon() {
        if (this.props.icon) {
            return <GeckoIcon icon={this.props.icon} />;
        }
        return null;
    }

    render() {
        
        return (
            <div className="gecko-card-header">

                {this.renderTitle()}

                <div className="header-container clearfix">

                    {this.props.children}

                </div>
                
            </div>            
        );
    }
}

export default GeckoCardHeader;